import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import PopoverOfForm from '../../../components/search/FormElements/PopoverOfForm/PopoverOfForm';
import fieldNames from './filenameTemplateFields';
import { notify } from '../../../components/common/Notification';
import { updateFilenameTemplate } from '../../../redux/actions/integrationsConnectionActions';


class FieldsSelector extends Component {
  validateMaxWords = () => {
    const { description_max_words } = this.props;
    if (description_max_words > 10) {
      notify.error(
        `Error!  Description max words exceeded (10): ${description_max_words}`,
        { position: 'top-center' },
      );
    }
  }

  changeMaxWords = (e) => {
    this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { description_max_words: e.target.value }));
  }

  changeDateFormat = (e) => {
    this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { date_format: e.target.value }));
  }

  validateDateFormat = () => {
    const { date_format } = this.props;
    if (date_format.match(/^[MMDDYYYY\- .]*$/) === null) {
      notify.error(
        `Error!  Bad date format: ${date_format}`,
        { position: 'top-center' },
      );
    }
  }

  render() {
    const {
      description_max_words,
      date_format,
      editableSection,
      root_folder,
      addField,
      addRootFolder,
    } = this.props;

    const isFolderPathEditable = editableSection === 'folder-path-configuration';
    const isFileFormatEditable = editableSection === 'file-format-configuration';

    return (
      <div className={`fields-selector left-panel ${editableSection === '' ? 'hidden' : ''}`}>
        <div className="field-group">
          <div className="label">Document Fields</div>
          <div className="fields">
            {fieldNames.filter(f => f.type === 'document').map((field, idx) => {
              let tooltip = null;
              let value = null;

              if (field.tooltip) {
                tooltip = field.tooltip();
              }

              if (field.name === 'document_description') {
                value = (
                  <React.Fragment>
                    <span>Doc Description of
                      <input type="text"
                             className="description-max-words"
                             onBlur={this.validateMaxWords}
                             onClick={(e) => {
                               // input field is a child of a clickable div.  prevent event from bubbling up to parent
                               e.stopPropagation();
                             }}
                             onChange={this.changeMaxWords}
                             value={description_max_words} />
                      words
                    </span>
                    {tooltip}
                  </React.Fragment>
                );
              } else {
                value = (
                  <React.Fragment>
                    <span>{field.value}</span> {tooltip}
                  </React.Fragment>
                );
              }
              return (
                <div key={`selectablef-${field.name}-${idx}`}
                     className="field"
                     onClick={() => addField(field.name)}>
                  {value}
                </div>
              );
            })}
          </div>
        </div>

        <div className="field-group">
          <div className="label">Case Related Fields</div>
          <div className="fields">
            {fieldNames.filter(f => f.type === 'case').map((field, idx) => (
              <div key={`selectablef2-${field.name}-${idx}`}
                   className="field"
                   onClick={() => addField(field.name)}>
                <span>{field.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="field-group">
          <div className="label">Court Related Fields</div>
          <div className="fields">
            {fieldNames.filter(f => f.type === 'court').map((field, idx) => (
              <div key={`selectablef3-${field.name}-${idx}`}
                   className="field"
                   onClick={() => addField(field.name)}>
                <span>{field.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="field-group">
          <div className="label">Formatting Options</div>
          <div className="fields separators-fields margin-top-5">
            {fieldNames.filter(x => x.type === 'separator').map((field, idx) => {
              const editable = (field.showOnFolderPathEdit && isFolderPathEditable)
                || (field.showOnFileFormatEdit && isFileFormatEditable);

              return (
                <div key={`sepfield-${field.name}-${idx}`}
                     className={`field-separator ${editable ? '' : 'hidden'}`}
                     onClick={() => addField(field.name)}>
                  {field.value}
                </div>
              );
            })}
          </div>
        </div>

        <div className="field-group">
          <div className="label">Date Format</div>
          <div className="fields margin-top-5">
            <div className={`field-no-hover date-format-selector ${isFolderPathEditable ? 'hidden' : ''}`}>
              <span>Date Format</span>
              <input type="text"
                     onChange={this.changeDateFormat}
                     onBlur={this.validateDateFormat}
                     value={date_format} />
              <PopoverOfForm>
                <p>Customize date field formats</p>
                <p>Must include at least one of the following: DD MM YYYY</p>
                <p>May use these field separators:</p>
                <p>. - [space] </p>
                <p>Examples:</p>
                <p>YYYY-MM-DD , MM-DD-YYYY, YYYY.MM.DD, YYYY DD</p>
              </PopoverOfForm>
            </div>
          </div>
        </div>

        <div className="field-group">
          <div className="label">Root Folder</div>
          <div className="fields margin-top-5">
            <div
              className={`field-no-hover date-format-selector ${isFolderPathEditable ? '' : 'hidden'}`}>
              <span>Root Folder</span>
              <input type="text"
                     onChange={addRootFolder}
                // onBlur={this.validateDateFormat}
                     value={root_folder} />
              <Button bsSize="xsmall"
                      bsStyle="primary"
                      className="add-btn"
                      onClick={() => addRootFolder(root_folder)}>
                add
              </Button>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

FieldsSelector.defaultProps = {
  hasAppFolder: false,
}

FieldsSelector.propTypes = {
  connectionId: PropTypes.number.isRequired,
  description_max_words: PropTypes.number.isRequired,
  date_format: PropTypes.string.isRequired,
  editableSection: PropTypes.string.isRequired,
  root_folder: PropTypes.string.isRequired,
  addField: PropTypes.func.isRequired,
  addRootFolder: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  hasAppFolder: PropTypes.bool,
};

export default FieldsSelector;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/FieldsSelector.jsx